module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel05_1280_1280_en-e523f1eaa7a698c39561c0c6f234f1d8.jpg";